import { render, staticRenderFns } from "./day-configurator-add-gift-modal.vue?vue&type=template&id=30cdd728&scoped=true&"
import script from "./day-configurator-add-gift-modal.vue?vue&type=script&lang=js&"
export * from "./day-configurator-add-gift-modal.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-add-gift-modal.vue?vue&type=style&index=0&id=30cdd728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdd728",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cdd728')) {
      api.createRecord('30cdd728', component.options)
    } else {
      api.reload('30cdd728', component.options)
    }
    module.hot.accept("./day-configurator-add-gift-modal.vue?vue&type=template&id=30cdd728&scoped=true&", function () {
      api.rerender('30cdd728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/modals/day-configurator-add-gift-modal.vue"
export default component.exports